<template>
  <div>
    <v-list-item
      :to="to || location(item)"
      :style="{paddingLeft: `${16 + depth * 20}px`}"
      :class="{'nav-child': depth > 0}"
      :data-cy="`nav-${item.name}`"
      exact
    >
      <v-list-item-content>
        <v-list-item-subtitle v-if="trail" class="text-caption">{{ trail }} ›</v-list-item-subtitle>
        <v-list-item-title>{{ title }}<span v-if="to && item.needs" class="text-caption"> · {{ idText }}</span></v-list-item-title>
        <v-list-item-subtitle class="nav-summary">{{ item.summary }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <template v-if="!trail && !to">
      <nav-item
        v-for="child of item.children || []"
        :key="child.name"
        :item="child"
        :location="location"
        :depth="depth + 1"
      />
    </template>
  </div>
</template>

<script>
import {pageTitle} from '@/nav-helpers';

/** one page in the navigation menu, with the pages it links to nested beneath it */
export default {
  name: 'NavItem',
  props: {
    item: {type: Object, required: true},
    location: {type: Function, required: true},
    depth: {type: Number, default: 0},
    /** search results show where the page sits instead of its children */
    trail: {type: String, default: ''},
    /** a recent visit links to where it was, ids and all, and leaves out the children */
    to: {type: Object, default: null},
  },
  computed: {
    idText() {
      return Object.values(this.to.params || {}).join(' ');
    },
    title() {
      return pageTitle(this.item);
    },
  },
};
</script>

<style scoped>
.nav-summary {
  white-space: normal;
}

.nav-child {
  min-height: 0;
  border-left: 2px solid rgba(0, 0, 0, 0.08);
}
</style>
